<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<template>
    <div class="sdev-global-notifications">
        <transition-group name="sdev-notification">
            <div v-for="notification in notifications" :key="notification.id" class="sdev-notification"
                :class="`is-${notification.type}`">
                <div class="sdev-notification__content">
                    {{ notification.message }}
                </div>

                <button class="sdev-notification__close" @click="remove(notification.id)">
                    ×
                </button>
            </div>
        </transition-group>
    </div>
</template>

<script setup>
import { useNotify } from '@/composables/useNotify'

const { notifications, remove } = useNotify()
</script>